// extracted by mini-css-extract-plugin
export default {"container":"container_eoE1e","title":"title_aMwDe","texts":"texts_XOGbe","text":"text_MfHNR","isSmall":"isSmall_Ryq3G"};